<template>
    <div class="accounting-detail-data accounting-payment-detail">
        <div class="detail-container">
            <div class="detail-section">
                <div class="accounting-detail-items" style="margin-top: 25px">
                    <div class="item vertical">
                        <div class="label">摘要</div>
                        <div class="value">
                            <div class="desc-block">{{ documentDetail.nam }}</div>
                        </div>
                    </div>
                </div>
                <div class="accounting-detail-items" style="margin-top: 25px">
                    <div class="item">
                        <div class="label">系統單號</div>
                        <div class="value">
                            <el-button type="text" @click="openPaymentDetail(documentDetail.sno)">{{ documentDetail.payoo }}</el-button>
                        </div>
                    </div>
                    <div class="item">
                        <div class="label">系統單狀態</div>
                        <div class="value"><PaymentStatusLabel :statusNum="documentDetail.sigN_STS" :isTempSaved="isTempSaved" /></div>
                    </div>
                    <div v-if="isFullInfoShow" class="item">
                        <div class="label">支出項目</div>
                        <div class="value">{{ getHierarchyItemNames(documentDetail.iteM_SNO) }}</div>
                    </div>
                    <div v-if="isFullInfoShow" class="item">
                        <div class="label">付款立帳科目</div>
                        <div class="value">
                            <span>{{ documentDetail.accno }} - {{ documentDetail.accnam }}</span>
                            <el-button v-if="isShowChangeAccnoBtn" size="mini" class="tiny-btn" icon="el-icon-edit" @click="openAccnoModifyDialog"></el-button>
                        </div>
                    </div>
                    <div v-if="isFullInfoShow" class="item">
                        <div class="label">付款沖帳科目</div>
                        <div class="value">
                            <span>{{ documentDetail.clearanceAccno }} - {{ documentDetail.clearanceAccnoNam }}</span>
                            <el-button v-if="isShowChangeAccnoBtn" size="mini" class="tiny-btn" icon="el-icon-edit" @click="openClearanceAccnoModifyDialog"></el-button>
                        </div>
                    </div>
                    <div class="item" v-if="documentDetail.pjcaT_SNO">
                        <div class="label">專案</div>
                        <div class="value">
                            <div>{{ documentDetail.pjcaT_NAM }}</div>
                            <!-- <div>#{{ documentDetail.poo }}</div> -->
                        </div>
                    </div>
                    <div class="item">
                        <div class="label">請款單日期</div>
                        <div class="value">{{ documentDetail.dat | dateFormater("YYYY-MM-dd") }}</div>
                    </div>
                    <div class="item">
                        <div class="label">付款對象</div>
                        <div class="value">
                            <div>({{ payTypeText }})</div>
                            <div v-if="documentDetail.vdR_SNO">{{ documentDetail.vdR_NAM }}</div>
                            <div v-else>{{ documentDetail.payName }}</div>
                        </div>
                    </div>
                    <div class="item" v-if="documentDetail.paY_TO == 3">
                        <div class="label">勞務所得類別</div>
                        <div class="value">{{ getServiceTypeTxt(documentDetail.serviceType) }}</div>
                    </div>
                    <div class="item spacing-top">
                        <div class="label">請款總額</div>
                        <div class="value large">
                            <Money :v="documentDetail.amt" :precision="documentDetail.cny === 'TWD' ? null : 4" /> <span class="cny">{{ documentDetail.cny }}</span>
                        </div>
                    </div>
                    <div class="item" v-if="documentDetail.taX_CHK">
                        <div class="label">代扣所得稅款</div>
                        <div class="value"><Money :v="documentDetail.taX_AMT * documentDetail.paY_CNYRAT" round /> <span class="cny">TWD</span></div>
                    </div>
                    <div class="item" v-if="documentDetail.geN2_CHK">
                        <div class="label">代扣二代健保</div>
                        <div class="value"><Money :v="documentDetail.geN2_AMT * documentDetail.paY_CNYRAT" round /> <span class="cny">TWD</span></div>
                    </div>
                    <div class="item">
                        <div class="label">實付金額</div>
                        <div class="value">
                            <Money :v="documentDetail.amt - documentDetail.taX_AMT - documentDetail.geN2_AMT" :precision="documentDetail.cny === 'TWD' ? null : 4" />
                            <span class="cny">{{ documentDetail.cny }}</span>
                        </div>
                    </div>
                    <div class="item" v-if="filesStatistics">
                        <div class="label">單據張數</div>
                        <div class="value">{{ filesStatistics.length }}</div>
                    </div>
                </div>
            </div>
            <!-- 付款資訊 -->
            <div v-if="isFullInfoShow" class="detail-section">
                <div class="section-title">實付金額<span v-if="isTempSaved">（暫存）</span></div>
                <div class="accounting-detail-items" style="margin-top: 25px">
                    <div class="item">
                        <div class="label">金額</div>
                        <div class="value">
                            <Money :v="documentDetail.amt - documentDetail.taX_AMT - documentDetail.geN2_AMT" :precision="documentDetail.cny === 'TWD' ? null : 4" />
                            <span class="cny">{{ documentDetail.cny }}</span>
                        </div>
                    </div>
                    <div class="item">
                        <div class="label">付款日期</div>
                        <div class="value">{{ documentDetail.paY_DAT | dateFormater("YYYY-MM-dd") }}</div>
                    </div>
                    <div class="item">
                        <div class="label">付款方式</div>
                        <div class="value">{{ getPayWayText(documentDetail.paY_WAY) }}</div>
                    </div>
                    <div class="item" v-if="documentDetail.paY_WAY !== 1">
                        <div class="label">付款帳戶</div>
                        <div class="value">{{ getBankAccountNameBySno(documentDetail.paY_BNK_SNO) }}</div>
                    </div>
                </div>
            </div>
            <!-- 代扣：勞務稅款 -->
            <div class="detail-section" v-if="documentDetail.taX_CHK">
                <div class="section-title">代扣：勞務稅款</div>
                <div class="accounting-detail-items" style="margin-top: 25px">
                    <div class="item">
                        <div class="label">金額</div>
                        <div class="value"><Money :v="documentDetail.taX_AMT * documentDetail.paY_CNYRAT" round /> <span class="cny">TWD</span></div>
                    </div>
                    <div class="item">
                        <div class="label">付款日期</div>
                        <div class="value">{{ documentDetail.taX_PAY_DAT | dateFormater("YYYY-MM-dd") }}</div>
                    </div>
                    <div class="item">
                        <div class="label">付款方式</div>
                        <div class="value">
                            <div v-if="!documentDetail.taX_BNK_SNO">零用現金</div>
                            <div v-else>{{ getPayWayText(documentDetail.paY_WAY) }}</div>
                        </div>
                    </div>
                    <div class="item" v-if="documentDetail.taX_BNK_SNO">
                        <div class="label">付款帳戶</div>
                        <div class="value">{{ getBankAccountNameBySno(documentDetail.taX_BNK_SNO) }}</div>
                    </div>
                </div>
            </div>
            <!-- 代扣：二代健保 -->
            <div class="detail-section" v-if="documentDetail.geN2_CHK">
                <div class="section-title">代扣：二代健保</div>
                <div class="accounting-detail-items" style="margin-top: 25px">
                    <div class="item" v-if="documentDetail.geN2_CHK">
                        <div class="label">金額</div>
                        <div class="value"><Money :v="documentDetail.geN2_AMT * documentDetail.paY_CNYRAT" round /> <span class="cny">TWD</span></div>
                    </div>
                    <div class="item">
                        <div class="label">付款日期</div>
                        <div class="value">{{ documentDetail.geN2_PAY_DAT | dateFormater("YYYY-MM-dd") }}</div>
                    </div>
                    <div class="item">
                        <div class="label">付款方式</div>
                        <div class="value">
                            <div v-if="!documentDetail.geN2_BNK_SNO">零用現金</div>
                            <div v-else>{{ getPayWayText(documentDetail.paY_WAY) }}</div>
                        </div>
                    </div>
                    <div class="item" v-if="documentDetail.geN2_BNK_SNO">
                        <div class="label">付款帳戶</div>
                        <div class="value">{{ getBankAccountNameBySno(documentDetail.geN2_BNK_SNO) }}</div>
                    </div>
                </div>
            </div>
            <!-- 檢附單據 -->
            <div class="detail-section" v-if="documentDetail.files && documentDetail.files.length === 0">
                <div class="section-title">檢附單據</div>
                <div>（無）</div>
            </div>
            <div class="detail-section" v-for="(file, index) in documentDetail.files" :key="index">
                <div class="section-title">檢附單據 #{{ index + 1 }}</div>
                <div class="split-view">
                    <div class="attachment-rect">
                        <div v-if="['jpeg', 'jpg', 'png'].includes(getFileExtByUrl(file.filE_ATT))" style="width: 120px; height: 158px">
                            <el-image style="width: 120px; height: 158px" :src="file.filE_ATT" :previewSrcList="[file.filE_ATT]" v-if="file.filE_ATT" fit="contain" />
                        </div>
                        <div v-else-if="file.filE_ATT" class="file-rect">
                            <ahFileIcon ext="pdf" :url="file.filE_ATT" />
                        </div>
                        <div v-else class="no-file-rect">
                            <span style="color: #aaa; cursor: default">未上傳</span>
                        </div>
                    </div>
                    <div class="accounting-detail-items" style="margin-top: 25px">
                        <div v-if="file.foo" class="item">
                            <div class="label">發票號碼</div>
                            <div class="value">
                                <span class="fw-b">{{ file.foo }}</span>
                            </div>
                        </div>
                        <div v-if="file.foO_DAT" class="item">
                            <div class="label">單據日期</div>
                            <div class="value">
                                <span class="fw-b">{{ file.foO_DAT | dateFormater("YYYY-MM-dd") }}</span>
                            </div>
                        </div>
                        <div v-if="file.amt && file.tax" class="item">
                            <div class="label">銷售額(未稅)</div>
                            <div class="value">
                                <Money :v="file.amt - file.tax" /> <span class="cny">{{ documentDetail.cny }}</span>
                            </div>
                        </div>
                        <div v-if="file.tax" class="item">
                            <div class="label">進項稅額</div>
                            <div class="value">
                                <Money :v="file.tax" /> <span class="cny">{{ documentDetail.cny }}</span>
                            </div>
                        </div>
                        <div v-if="file.amt" class="item">
                            <div class="label">單據總額</div>
                            <div class="value">
                                <Money :v="file.amt" /> <span class="cny">{{ documentDetail.cny }}</span>
                            </div>
                        </div>
                        <div class="item">
                            <div class="label">上傳日期</div>
                            <div class="value">
                                <el-tooltip class="item" effect="dark" :content="formateTimestamp(documentDetail.crT_DAT)" placement="top">
                                    <span>{{ documentDetail.crT_DAT | dateFormater("YYYY-MM-dd") }}</span>
                                </el-tooltip>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="isAuth('G06')" style="margin-top: 10px; text-align: right">
                    <el-button size="small" :disabled="(!isPayed('G01') && !isAuth('admin')) || isEditing" @click="onGenerateTaxVoucher(file)">做傳票</el-button>
                </div>
            </div>
        </div>
        <PaymentDetailDialog @close="handlePaymentDetailDialogClose" :visible="paymentDetailDialog.visible" :sno="paymentDetailDialog.sno" />
        <PaymentAccnoModifyDialog
            :typ="2"
            :unT_NBR="documentDetail.payoo"
            :itemSno="documentDetail.iteM_SNO"
            :accno="documentDetail.accno"
            :visible="accnoModifyDialog.visible"
            @accno-changed="$emit('detail-data-changed')"
            @regenerate-vouchers="$emit('regenerate-vouchers')"
            @close="handleAccnoModifyDialogClose"
        />
        <ClearanceAccnoModifyDialog
            :typ="2"
            :unT_NBR="documentDetail.payoo"
            :clearance-accno="documentDetail.clearanceAccno"
            :visible="clearanceAccnoModifyDialog.visible"
            @accno-changed="$emit('detail-data-changed')"
            @regenerate-vouchers="$emit('regenerate-vouchers')"
            @close="handleClearanceAccnoModifyDialogClose"
        />
    </div>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import { serviceTypeList, PAY_WAY_LIST } from '@/assets/commonData/options';
import PaymentStatusLabel from '@/components/dashboard/Payment/PaymentStatusLabel.vue';
import ahFileIcon from '@/components/ui/ahFileIcon.vue';

export default {
    props: {
        datas: {
            type: Object,
            default: () => {},
        },
        isEditing: Boolean,
    },
    components: {
        PaymentStatusLabel,
        ahFileIcon,
        PaymentDetailDialog: () => import('@/components/dashboard/Payment/PaymentDetailDialog.vue'),
        PaymentAccnoModifyDialog: () => import('../ui/PaymentAccnoModifyDialog.vue'),
        ClearanceAccnoModifyDialog: () => import('../ui/ClearanceAccnoModifyDialog.vue'),
    },
    data() {
        return {
            arriveTypeList: {
                income: [
                    { sno: 0, label: '銀行匯款' },
                    { sno: 1, label: '收現金存銀行' },
                    { sno: 2, label: '收現金存零用金' },
                ],
                return: [
                    { sno: 0, label: '銀行匯款' },
                    { sno: 2, label: '零用現金退費' },
                ],
            },
            fileTypes: [],
            bankAccountList: [],
            paymentDetailDialog: {
                visible: false,
                sno: null,
            },
            accnoModifyDialog: {
                visible: false,
            },
            clearanceAccnoModifyDialog: {
                visible: false,
            },
        };
    },
    computed: {
        documentDetail() {
            return this.datas.detail || {};
        },
        payTypeText() {
            switch (this.documentDetail.paY_TO) {
            case 1:
                return '公司員工';
            case 2:
                return '廠商';
            case 3:
                return '委外勞務';
            default:
                return '';
            }
        },
        filesStatistics() {
            const total = _.sumBy(this.documentDetail.files, 'amt');
            const tax = _.sumBy(this.documentDetail.files, 'tax');

            return {
                total,
                tax,
                nonTax: total - tax,
                length: this.documentDetail.files ? this.documentDetail.files.length : 0,
            };
        },
        // filesTaxTotal() {},
        // filesNonTaxTotal() {},

        isTempSaved() {
            return this.documentDetail.sigN_STS === 5 && this.documentDetail.a02_ISTEMP;
        },
        isFullInfoShow() {
            return this.documentDetail.sigN_STS === 2 || this.documentDetail.sigN_STS === 3 || this.isTempSaved;
        },
        userGrP_NO() {
            return this.$store.getters['account/userGrP_NO'];
        },
        isSAAdmin() {
            return this.$store.getters['account/isSAAdmin'];
        },
        isShowChangeAccnoBtn() {
            if (this.userGrP_NO === 'OT1' || this.userGrP_NO === 'OT6') {
                return false;
            }
            return this.userGrP_NO === 'OT2' || this.userGrP_NO === 'OT3' || this.userGrP_NO === 'OT4' || this.userGrP_NO === 'OT5' || this.isSAAdmin;
        },
    },
    created() {
        this.fetchFileTypes();
        this.fetchBankAccountData();
    },
    methods: {
        getHierarchyItemNames(itemNo) {
            const hierarchy = [null, null, null];

            const types = [
                { key: 'payoutSettings', name: '營業支出' },
                { key: 'invoiceSettings', name: '營業收入' },
                { key: 'cInSettings', name: '營業其他收入' },
                { key: 'cInElseSettings', name: '財務資產收入' },
                { key: 'cOutSettings', name: '營業其他支出' },
                { key: 'cOutElseSettings', name: '財務資產支出' },
            ];

            // eslint-disable-next-line no-restricted-syntax, guard-for-in
            for (const t in types) {
                const options = this.$store.getters['statement/statementUiOptions'][types[t].key];
                // eslint-disable-next-line no-restricted-syntax, guard-for-in
                for (const i in options) {
                    const lv1Item = options[i];
                    // eslint-disable-next-line no-restricted-syntax, guard-for-in
                    for (const j in lv1Item.childSettings) {
                        const lv2Item = lv1Item.childSettings[j];
                        if (lv2Item.sno === itemNo) {
                            hierarchy[0] = types[t].name;
                            hierarchy[1] = lv1Item.iteM_NAM;
                            hierarchy[2] = lv2Item.iteM_NAM;
                            break;
                        }
                    }
                }
            }

            return hierarchy.join(' / ');
        },
        getReceiveIncomeTypeText(flg, typeSno) {
            const typeList = flg > 0 ? this.arriveTypeList.income : this.arriveTypeList.return;
            return _.find(typeList, ['sno', typeSno]).label;
        },
        getServiceTypeTxt(serviceTypeNum) {
            const s = serviceTypeList.find((x) => x.value === serviceTypeNum);
            if (s) return s.label;
            return '';
        },

        async fetchFileTypes() {
            const resp = await this.$api({
                url: '/PaymentManagenmentPage/GetAttachTypeOption',
                method: 'GET',
            });
            this.fileTypes = resp.data.items;
        },
        async fetchBankAccountData() {
            // 經常性費用
            const resp = await this.$api({
                url: '/Tool/GetBankAccountOptions',
                method: 'GET',
            });
            this.bankAccountList = resp.data.options;
        },
        getFileType(type) {
            if (this.fileTypes && type) {
                const iy = this.fileTypes.find((x) => x.key === type);
                if (iy) return iy.value;
            }
            return '--';
        },
        getFileExtByUrl(url) {
            return url.split('.').pop().toLowerCase();
        },
        getPayWayText(val) {
            return _.find(PAY_WAY_LIST, ['value', val])?.label || '--';
        },
        getBankAccountNameBySno(sno) {
            if (sno === null || sno < 0) return ''; // 零用現金付款

            const bankAccount = this.bankAccountList.find((item) => item.sno === sno);
            if (bankAccount) {
                return bankAccount.tpc;
            }

            return '---';
        },
        openPaymentDetail(sno) {
            this.paymentDetailDialog.sno = sno;
            this.paymentDetailDialog.visible = true;
        },
        handlePaymentDetailDialogClose(refresh) {
            this.$emit('detailClose', refresh);
            this.paymentDetailDialog.visible = false;
            this.paymentDetailDialog.sno = null;
        },

        openAccnoModifyDialog() {
            // this.accnoModifyDialog.accno = this.documentDetail.accno;
            this.accnoModifyDialog.visible = true;
        },
        openClearanceAccnoModifyDialog() {
            // this.clearanceAccnoModifyDialog.accno = this.documentDetail.accno;
            this.clearanceAccnoModifyDialog.visible = true;
        },
        handleAccnoModifyDialogClose(refresh) {
            this.accnoModifyDialog.visible = false;
            if (refresh) {
                this.$emit('detail-data-changed');
            }
        },
        handleClearanceAccnoModifyDialogClose(refresh) {
            this.clearanceAccnoModifyDialog.visible = false;
            if (refresh) {
                this.$emit('detail-data-changed');
            }
        },
        onGenerateTaxVoucher(data) {
            this.$emit('generate', 'payment', data);
        },
        formateTimestamp(timestamp) {
            return moment(timestamp).format('YYYY年MM月DD日 HH:mm');
        },
    },
};
</script>

<style lang="scss">
.accounting-payment-detail {
    .tiny-btn {
        margin-left: 8px;
        padding: 5px 12px;
        border-radius: 5px;
    }
}
</style>
